// Condición canónica de "está facturado" para las oportunidades de Facturación.
//
// Regla 10.187: la condición de facturado debe ser IDÉNTICA en todas las vistas
// (filtro Estado, card BRUTO y numerador del % FACTURADO). Antes vivía duplicada
// dentro de useVFFiltering: el filtro/BRUTO usaba `facturanumero` O vinculación SII
// por `siiMap._byRef`, pero el numerador `totalFacturado` solo miraba `facturanumero`,
// ignorando la vinculación SII → el % FACTURADO divergía según el dataset estuviera
// filtrado por Estado o no. Centralizar acá evita que puedan volver a divergir.
//
// L6 tramo 5c (10.264 — existencia de documento, no de fecha): el folio deja de decidir
// "facturado" por sí solo PARA CARTELERÍA 2026 (alcance real de la migración L6 — Chile, 10.265).
// Si el folio de la línea resuelve a un documento QUE EXISTE en `siiMap`, la vinculación real (el
// puente, vía `refKeyDeOportunidad`/`siiMap._byRef`) es la ÚNICA fuente — un folio de texto sin
// puente real ya no pinta verde. Fuera de ese alcance (Perú, o cartelería pre-2026, o pauta/BTL/
// contrato) el folio sigue siendo la única fuente posible, SIN EXCEPCIÓN — ni siquiera si por
// coincidencia matchea un documento real: medido en vivo, 11 líneas de cartelería 2025 coinciden
// hoy en folio con facturas de diciembre-2025 cargadas el mismo día por otro frente (vinculadas a
// un movimiento bancario, no al puente de esa línea) — sin este gate por año, esas 11 pasarían de
// facturado a no-facturado, violando la condición de seguridad del tramo. Mismo principio que el
// `facturafechacobro` manual pre-SII de `resolverCobroVenta`: sin nada más contra qué validar el
// folio, sobrevive tal cual estaba.
import { refKeyDeOportunidad } from "./lineasFacturacion/refKey";

export const tieneFactura = (oportunidad, siiMap) => {
  const folio = oportunidad?.facturanumero ? String(oportunidad.facturanumero).trim() : "";
  const esCarteleria2026 = !!oportunidad?.negocio_id && String(oportunidad?.ano) === "2026";
  if (folio && (!esCarteleria2026 || !siiMap?.[folio])) return true;
  if (!siiMap?._byRef) return false;
  const refKey = refKeyDeOportunidad(oportunidad);
  return refKey ? !!siiMap._byRef[refKey] : false;
};
